import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { ModalComponent } from "./modals/modal.component";
import { DatePipe } from "./pipes/datePipe";
import { ShamsiDatePipe } from "./pipes/shamsiDatePipe";

@NgModule({
    declarations: [
      ModalComponent,
      ShamsiDatePipe,
      DatePipe
    ],
    imports: [],
    exports: [
        CommonModule,
        TranslateModule,
        ModalComponent,
        ShamsiDatePipe,
        DatePipe
    ],
    providers:[DatePipe, ShamsiDatePipe]
})
export class SharedModule { }